import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class EventService
{

  constructor(private http: HttpClient) { }

  public updateEvent(data: any): Observable<any>
  {
    return this.http.put('/event', data);
  }

  public getEvent(id: number, taskId: string): Observable<any>
  {
    return this.http.get<any>(`/event/${id}/task/${taskId}`);
  }

  public getCountClinicalEventsByUser(): any
  {
    return this.http.get<any[]>(`/event/dashboard/notice`);
  }

  public getClinicalEventsByUser(): any
  {
    return this.http.get<any[]>(`/event/dashboard/events`);
  }
}
